import { ReactComponent as VerticalEllipsis } from '../../../assets/vertical-ellipsis.svg'

export const VerticalEllipsisIcon = () => (
    <VerticalEllipsis height="20" width="20" />
)